export const allComplaintsSelector = (state) => state.complaint;
export const allComplaintsTypesSelector = (state) =>
    state.complaint.complaintsTypes;
export const allComplaintsUsersSelector = (state) =>
    state.complaint.complaintsUsers;
export const allComplaintsUserSelector = (state) =>
    state.complaint.complaintsUser;
export const allComplaintParamsSelector = (state) => state.complaint.params;
